import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { RadioListItemValue } from '@domgen/dgx-fe-components-core';
import { Product } from '../product-card/product-card.component';
import { AvailableCover } from '@common/util-models';

import { UpgradeCoverConfig } from '@common/util-models';

@Component({
  selector: 'wl-cover-selection',
  templateUrl: './cover-selection.component.html',
  styleUrls: ['./cover-selection.component.scss'],
})
export class CoverSelectionComponent implements OnChanges {
  @Input() selectedProduct: RadioListItemValue = null;
  @Input() availableCovers: AvailableCover[] | null = [];
  @Input() alternateProduct?: UpgradeCoverConfig | undefined | null;
  @Output() coverChange: EventEmitter<RadioListItemValue> = new EventEmitter();
  @Output()
  alternateProductSelection: EventEmitter<UpgradeCoverConfig> = new EventEmitter();
  @Input() isInsurance: boolean | null = false;
  @Input() discountApplied: boolean | null = false;

  products: Product[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.availableCovers) {
      return;
    }
    this.mapToProductObject(this.availableCovers ? this.availableCovers : []);
  }

  onSelectionChange(id: RadioListItemValue) {
    if (this.coverChange?.observers?.length) {
      this.coverChange.emit(id);
    } else {
      this.selectedProduct = id;
    }
  }
  handleAlternateProductSelection(product: UpgradeCoverConfig) {
    this.alternateProductSelection.emit(product);
  }

  mapToProductObject(availableCovers: AvailableCover[]) {
    const initialCover = availableCovers.find((cover) => !cover.isUpgrade);
    let initialCoverPrice = 0;
    let coverPrice = 0;
    const initialCoverPriceDiscounted =
      initialCover?.paymentOptions.directDebit?.firstDiscountPayment || 0;

    this.products = availableCovers.map((cover: AvailableCover) => {
      if (this.discountApplied) {
        initialCoverPrice =
          initialCover?.paymentOptions.directDebit?.subsequentDiscountPayment ||
          0;
        coverPrice =
          cover.paymentOptions.directDebit?.subsequentDiscountPayment || 0;
      } else {
        initialCoverPrice =
          initialCover?.paymentOptions.directDebit?.subsequentDiscountPayment ||
          0;
        coverPrice = cover.paymentOptions.directDebit?.subsequentPayment || 0;
      }

      const discountedCoverPrice =
        cover.paymentOptions.directDebit?.firstDiscountPayment || 0;

      const discountPeriod =
        cover.paymentOptions.directDebit?.discountPeriod || 0;
      const numPayments = cover.paymentOptions.directDebit?.numPayments || 0;

      const coverObj: Product = {
        id: cover.coverType,
        title: (cover.isUpgrade ? 'Upgrade to ' : '') + cover.name,
        perMonthPrice: coverPrice,
        discountedMonthlyPrice: this.discountApplied ? discountedCoverPrice : 0,
        extraCost: cover.isUpgrade ? coverPrice - initialCoverPrice : 0,
        discountedExtraCost:
          cover.isUpgrade && this.discountApplied
            ? discountedCoverPrice - initialCoverPriceDiscounted
            : 0,
        yearlyPrice: cover.paymentOptions.directDebit?.fee || 0,
        isUpgrade: cover.isUpgrade,
        desc: cover.description,
        discountTerm: `1 to ${discountPeriod}`,
        subsequentTerm: `${discountPeriod + 1} to ${numPayments}`,
        discount: this.discountApplied,
      };
      return coverObj;
    });
  }
}
